<template lang="pug">
.info-page
  article(v-if="info")
    section(v-html="html(info.data.text)")
    section.clients
      h1.heading Select Clients
      div(v-for="list in info.data.clients")
        h2.heading(v-html="list.header[0].text")
        div(v-html="html(list.list)")
    footer 
      copyright(credits)
</template>

<script>
import Vue from 'vue'
import Copyright from '@/components/Copyright'
export default {
  name: 'Info',
  props: ['info'],
  inheritAttrs: false,
  components: {
    Copyright
  },
  data () {
    return {
      html: Vue.$html
    }
  }
}
</script>

<style lang="scss">
@import '../style/variables';
.info-page{
  padding: em(50px) $pad $page-pad-b;
  article{
    max-width: 550px/$doc-font * 1em;
    margin: 0 auto;
  }

  .clients{
    margin: 3.125em auto 0;
    @include clearFloat();

    h1,h2{
      text-align: center;
      margin-bottom: 2.25em;
    }

    h1{
      padding-bottom: 2em;
      border-bottom-style: solid;
    }

    > div{
      width:50%;
      float:left;
      text-align: left;
      font-variant:small-caps;
      line-height: (17/16);
      &:nth-of-type(2n){
        padding-left:1.25em;
      }

      p{
        margin:0;
      }
    }
  }

  footer{
    margin-top: 4.5em;
  }
}

@include onMobile () {
  .info-page{
    padding-top: em(60px);
    .clients{
      > div{
        width:100%;
        float:none;
        padding:0 !important;
        & + div {
          margin-top: 1em;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Info.vue?2db80896